import Image from '@atlaskit/image';
import lowFiImage from "../../../../src/pages/foundations/illustrations/_assets/low-fi-light.png";
import lowFiImageDark from "../../../../src/pages/foundations/illustrations/_assets/low-fi-dark.png";
import colorSpotsImage from "../../../../src/pages/foundations/illustrations/_assets/color-spots-light.png";
import colorSpotsImageDark from "../../../../src/pages/foundations/illustrations/_assets/color-spots-dark.png";
import ambientLight from "../../../../src/pages/foundations/illustrations/_assets/ambient-light.png";
import ambientDark from "../../../../src/pages/foundations/illustrations/_assets/ambient-dark.png";
import doMeaningImage from "../../../../src/pages/foundations/illustrations/_assets/do-meaning-image.png";
import doSupportCopy from "../../../../src/pages/foundations/illustrations/_assets/do-support-copy.png";
import dontDecorativeOnly from "../../../../src/pages/foundations/illustrations/_assets/dont-decorative-only.png";
import dontOveruseImages from "../../../../src/pages/foundations/illustrations/_assets/dont-overuse-images.png";
import * as React from 'react';
export default {
  Image,
  lowFiImage,
  lowFiImageDark,
  colorSpotsImage,
  colorSpotsImageDark,
  ambientLight,
  ambientDark,
  doMeaningImage,
  doSupportCopy,
  dontDecorativeOnly,
  dontOveruseImages,
  React
};